<div class="container">
    <h1 class="page-title"
      [helpCenterButton]="permissionCode" [lang]="currentLang"
      [helpCenterDownloadButton]="permissionCode" [position]="'inline'" [lang]="currentLang">
    <span class="icon">
      <em class="fas fa-thermometer-half"></em>
    </span>
    {{ "EnvironmentMonitor.Header" | translate }}
  </h1>

  <p-card>
    <p-accordion>
      <p-accordionTab
        header="{{ 'Common.Form.Header' | translate }}"
        [selected]="isSearchFormOpen"
      >
        <form [formGroup]="searchForm">
          <div class="p-fluid grid">
            <div class="field col-12 md:col-6 lg:col-3 mb-3">
              <p class="mt-0 mb-2">
                {{ "EnvironmentMonitor.SearchForm.Facility" | translate }}
              </p>
              <laas-facility-dropdown 
                formControlName="facility" 
                [isSingle]="true" 
                (onOptionDataChange)="optionsDataOnChange($event, 'facility')">
              </laas-facility-dropdown> 
            </div>
            <div class="field col-12 md:col-6 lg:col-3 mb-3">
              <p class="mt-0 mb-2">
                {{ "EnvironmentMonitor.SearchForm.Floor" | translate }}
              </p>
              <p-dropdown
                [filter]="true"
                placeholder="{{ 'Common.DropDown.Select' | translate }}"
                [options]="floorOptions"
                formControlName="floor"
                [(ngModel)]="searchSensorInfoOptionsRequest.floor"
                (onChange)="getSensorAreaOptions()"
              ></p-dropdown>
            </div>
            <div class="field col-12 md:col-6 lg:col-3 mb-3">
              <p class="mt-0 mb-2">
                {{ "EnvironmentMonitor.SearchForm.Area" | translate }}
              </p>
              <p-dropdown
                [filter]="true"
                placeholder="{{ 'Common.DropDown.Select' | translate }}"
                [options]="areaOptions"
                formControlName="area"
                [(ngModel)]="searchSensorInfoOptionsRequest.area"
              ></p-dropdown>
            </div>

            <div class="field col-12 md:col-6 lg:col-3 laas-calendar">
              <laas-calendar
                #MonitorDt
                [title]="'EnvironmentMonitor.SearchForm.MonitorDt'"
                [enableMaxDateIsToday]="false"
                [showRangeMode]="true"
                [showStartMode]="true"
                [monthRange]="1"
                [requiredStar]="true"
                [defaultDate]="defaultMonitorDt"
                (onDateChange)="dateOnChange($event, 'monitorDt')">
              </laas-calendar>
            </div>
          </div>
          <div class="col">
            <button
              pButton
              pRipple
              label="{{ 'Common.Button.Search' | translate }}"
              (click)="searchBtnClick()"
            ></button>
            <button
              pButton
              pRipple
              label="{{ 'Common.Button.Reset' | translate }}"
              class="p-button-secondary ml-4"
              (click)="resetBtnClick()"
            ></button>
          </div>
        </form>
      </p-accordionTab>

      <ng-content *ngTemplateOutlet="HeaderTemplate"></ng-content>
    </p-accordion>
  </p-card>
</div>

<!--Header-->
<ng-template #HeaderTemplate>
  <div class="mt-2">
    <laas-data-table
      #table
      [value]="results"
      [loading]="isLoading"
      [defaultColumns]="columns"
      dataKey="rowId"
      [tableKey]="preferenceKey">
      <ng-template pTemplate="body" let-rowData let-columns="columns">
        <td *ngFor="let col of columns">
          <ng-container [ngSwitch]="col.field">
            <ng-container *ngSwitchCase="'facility'">
              {{ rowData[col.field] | optionsMapping : facilityOptions }}
            </ng-container>
            <ng-container *ngSwitchCase="'monitorDt'">
              <div class="overflow-text">
                {{
                  rowData[col.field]
                    | date : "yyyy-MM-dd HH:mm:ss" : this.laasSetting.facilityTimeZone
                    | replaceNullWith : "-"
                }}
              </div>
            </ng-container>
            <ng-container *ngSwitchDefault>
              <div class="overflow-text">
                {{ rowData[col.field] | replaceNullWith : "-" }}
              </div>
            </ng-container>
          </ng-container>
        </td>
      </ng-template>
    </laas-data-table>
  </div>
</ng-template>
<help-dock
  [permissionCode]="permissionCode"
  [lang]="currentLang">
</help-dock>
